export default {
  addReplie(state, payload) {
    const taskId = payload.taskId;
    const updateAble = {
      Commentdate: payload.Commentdate,
      comment: payload.comment,
      feedBy: payload.feedBy,
    };
    const obj = state.tasks.find((task) => task.id === taskId).feedback || {};
    state.tasks.find((task) => task.id === taskId).feedback = {
      ...obj,
      [payload.name]: updateAble,
    };
  },

  addTask(state, payload) {
    state.tasks.push(payload);
  },
  setTask(state, payload) {
    state.tasks = payload;
    if (payload.length !== 0) {
      state.loadedProjectId = payload[0].taskId;
    }
  },

  updateMode(state, payload) {
    state.tasks
      .filter((x) => x.taskId === payload.taskId)
      .find((y) => y.id === payload.id).mode = payload.mode;
  },
};
